export enum PaymentMode {
  CashOnDelivery = 'Cash On Delivery',
  Card = 'Pay By Card',
}

export enum EPaymentMode {
  Card = 1,
  CashOnDelivery = 2,
}

export interface BillingPaymentModal {
  orderId: string;
  transactionToken?: string;
  paymentMode: number;
  amount: number;
  firstName: string;
  lastName: string;
  billingAddress: string;
  billingAddress2?: string;
  billingCity: string;
  billingState: string;
  billingZip: string;
  nameOnCard?: string;
  cardNumber?: string;
  expMonth?: number;
  expYear?: number;
  currency?: string;
  cvv?: string;
  returnUrl?: string;
}

export interface PaymentResponses {
  success: boolean;
  data: string;
  statusCode: number;
  errors: string[];
  errorMessages: string[];
  message: string;
}

export enum PaymentStatus {
  All = -1,
  Paid = 0,
  Pending = 1,
  Partial = 2,
  Fail = 3,
  Term = 4,
  Prepaid=5,
  Deferred = 6
}

export interface PaymentStatusRes {
  key: number,
  value: PaymentStatus
}
